<template>
  <div class="WordSection1" style="layout-grid:15.6pt">
    <p
      class="MsoNormal"
      align="center"
      style="text-align:center;mso-pagination:widow-orphan;
background:white"
    >
    <span lang="EN-US" style='font-size:18.0pt;font-family:"Arial",sans-serif'
        >GF-4 Satellite</span
      >
    </p>
    <hr class="divider" />
    <p
      class="MsoNormal"
      align="center"
      style="text-align:center;mso-pagination:widow-orphan;
background:white"
    >
      <span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;font-family:
"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt;
mso-no-proof:yes'
        ><!--[if gte vml 1
          ]><v:shapetype
            id="_x0000_t75"
            coordsize="21600,21600"
            o:spt="75"
            o:preferrelative="t"
            path="m@4@5l@4@11@9@11@9@5xe"
            filled="f"
            stroked="f"
          >
            <v:stroke joinstyle="miter" />
            <v:formulas>
              <v:f eqn="if lineDrawn pixelLineWidth 0" />
              <v:f eqn="sum @0 1 0" />
              <v:f eqn="sum 0 0 @1" />
              <v:f eqn="prod @2 1 2" />
              <v:f eqn="prod @3 21600 pixelWidth" />
              <v:f eqn="prod @3 21600 pixelHeight" />
              <v:f eqn="sum @0 0 1" />
              <v:f eqn="prod @6 1 2" />
              <v:f eqn="prod @7 21600 pixelWidth" />
              <v:f eqn="sum @8 21600 0" />
              <v:f eqn="prod @7 21600 pixelHeight" />
              <v:f eqn="sum @10 21600 0" />
            </v:formulas>
            <v:path
              o:extrusionok="f"
              gradientshapeok="t"
              o:connecttype="rect"
            />
            <o:lock v:ext="edit" aspectratio="t" /> </v:shapetype
          ><v:shape
            id="图片_x0020_1"
            o:spid="_x0000_i1025"
            type="#_x0000_t75"
            style="width:375pt;height:225pt;visibility:visible;mso-wrap-style:square"
          >
            <v:imagedata src="GF4.files/image001.png" o:title="" /> </v:shape><!
        [endif]--><img
          width="500"
          height="300"
          src="../../assets/GF4sat.png"
          v:shapes="图片_x0020_1"/></span

      ><span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
        ><o:p></o:p
      ></span>
    </p>

    <p
      class="MsoNormal"
      style="text-indent:24.0pt;line-height:21.0pt;mso-pagination:
widow-orphan;background:white;text-align: left;"
    >
      <span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;
font-family:"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:
0pt'
        >GF-4 satellite was successfully launched at
        <span class="SpellE">Xichang</span> Satellite Launch Center on December
        29, 2015. It is the first earth geostationary orbit satellite in China.
        It is equipped with a staring camera with 50 meters visible /400 meters
        mid-wave infrared and a swath of more than 400 kilometers. It uses frame
        array staring mode to image with visible, multispectral and infrared
        imaging capabilities, the design life cycle is 8 years, through
        orientation control to achieve observation of China and surrounding
        areas. GF-4 can provide fast, reliable and stable optical remote sensing
        data for disaster reduction, forestry, earthquake, meteorology and other
        applications in China. It provides new technical means for disaster risk
        early warning and prediction, forest fire disaster monitoring, seismic
        structure information extraction, meteorological and weather monitoring,
        and opens new application fields for high resolution earth observation
        with geostationary orbit in China. At the same time, the GF-4 has great
        potential of applications in environmental protection, marine,
        agriculture, water conservancy and other industries as well as regional
        applications. The main users of GF-4 satellite are Ministry of Civil
        Affairs, State Forestry and Grassland Administration, China Earthquake
        Administration Bureau and China Meteorological Administration
        Bureau.<o:p></o:p
      ></span>
    </p>

    <p
      class="MsoNormal"
      align="left"
      style="text-align:left;mso-pagination:widow-orphan;
background:white"
    >
      <b
        ><span
          lang="EN-US"
          style='font-size:12.0pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
          >Orbit parameters<o:p></o:p></span
      ></b>
    </p>

    <table
      class="MsoNormalTable"
      border="1"
      cellspacing="0"
      cellpadding="0"
      
      style="width:95%;border-collapse:collapse;border:none;mso-border-alt:solid #DDDFE4 .75pt;
 mso-yfti-tbllook:1184"
    >
      <thead>
        <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes">
          <td
            style="border:solid #DDDFE4 1.0pt;mso-border-alt:solid #DDDFE4 .75pt;
   background:#C1CCE4;padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                  >Item<o:p></o:p></span
              ></b>
            </p>
          </td>
          <td
            style="border:solid #DDDFE4 1.0pt;border-left:none;mso-border-left-alt:
   solid #DDDFE4 .75pt;mso-border-alt:solid #DDDFE4 .75pt;background:#C1CCE4;
   padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;color:black;mso-color-alt:
   windowtext;mso-font-kerning:0pt"
                  >Parameter</span
                ></b
              ><b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
   mso-font-kerning:0pt"
                  ><o:p></o:p></span
              ></b>
            </p>
          </td>
        </tr>
      </thead>
      <tr style="mso-yfti-irow:1">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Orbit<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Sun-synchronous orbit<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:2">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Orbit altitude<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >36000 km<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:3;mso-yfti-lastrow:yes">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Designated location<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >105.6°E<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
    </table>

    <p
      class="MsoNormal"
      align="left"
      style="text-align:left;mso-pagination:widow-orphan;
background:white"
    >
      <b
        ><span
          lang="EN-US"
          style='font-size:12.0pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
          >Sensor technical parameters<o:p></o:p></span
      ></b>
    </p>

    <table
      class="MsoNormalTable"
      border="1"
      cellspacing="0"
      cellpadding="0"
      width="820"
      style="width:95%;border-collapse:collapse;border:none;mso-border-alt:solid #DDDFE4 .75pt;
 mso-yfti-tbllook:1184"
    >
      <thead>
        <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes">
          <td
            style="border:solid #DDDFE4 1.0pt;mso-border-alt:solid #DDDFE4 .75pt;
   background:#C1CCE4;padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                  >Item<o:p></o:p></span
              ></b>
            </p>
          </td>
          <td
            colspan="3"
            style="border:solid #DDDFE4 1.0pt;border-left:none;mso-border-left-alt:
   solid #DDDFE4 .75pt;mso-border-alt:solid #DDDFE4 .75pt;background:#C1CCE4;
   padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;color:black;mso-color-alt:
   windowtext;mso-font-kerning:0pt"
                  >Parameter</span
                ></b
              ><b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
   mso-font-kerning:0pt"
                  ><o:p></o:p></span
              ></b>
            </p>
          </td>
        </tr>
      </thead>
      <tr style="mso-yfti-irow:1">
        <td
          rowspan="6"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral band<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          rowspan="5"
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Visible and near infrared<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Panchromatic<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.45</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.90 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:2">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Blue<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.45</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.52 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:3">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Green<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.52</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.60 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:4">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Red<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.63</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.69 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:5">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Near-infrared<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.76</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.90 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:6">
        <td
          colspan="2"
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Medium wave infrared (MWIR)<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >3.50</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >4.10 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:7">
        <td
          rowspan="2"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >GSD<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          colspan="2"
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >VNIR<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >50 m<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:8">
        <td
          colspan="2"
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >MWIR<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >400 m<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:9">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Swath width<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          colspan="3"
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >400 km<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:10;mso-yfti-lastrow:yes">
        <td
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Site re-visit period<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          colspan="3"
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >20s<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
    </table>

    <p class="MsoNormal">
      <span lang="EN-US"><o:p>&nbsp;</o:p></span>
    </p>
  </div>
</template>
